import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private _authService: AuthService;
	private _jwtHelper: JwtHelperService;
	private _isRefreshing = false;

	constructor(authService: AuthService, jwtHelperService: JwtHelperService) {
		this._authService = authService;
		this._jwtHelper = jwtHelperService;
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const token = this._authService.token;
// TODO: figyelni, hogy csak olyan helyre küldjünk jwt-t ahová kell (enviroments-ből szedjuk az infot)
		if (token && !this._jwtHelper.isTokenExpired(token)) {
			const cloned = req.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`
				}
			});
			return next.handle(cloned);
		}

		return next.handle(req);
	}
}
